import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
export const routes: Routes = [
  {path:"", redirectTo: "Attractions-Level_Detail", pathMatch: 'full'},

  { path: "Attractions-Level_Detail", loadComponent: () => import('app/Attractions/attractions_level_detail.component').then( m => m.Attractions_Level_DetailComponent)} ,
  { path: "TravelAgencyMaster-Level_Detail", loadComponent: () => import('app/TravelAgencyMaster/travelagencymaster_level_detail.component').then( m => m.TravelAgencyMaster_Level_DetailComponent)} ,
  { path: "Chat-Level_Detail", loadComponent: () => import('app/Chat/chat_level_detail.component').then( m => m.Chat_Level_DetailComponent)} 
];